<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">司机手机号:</span>
                        <!-- 搜索司机手机号 -->
                        <el-input
                            v-model="search_data.driver_phone"
                            placeholder="请输入司机手机号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchInviteDriverCodeList"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">查询时间:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 350px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">用户手机号:</span>
                        <!-- 搜索用户手机号 -->
                        <el-input
                            v-model="search_data.phone"
                            placeholder="请输入用户手机号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchInviteDriverCodeList"
                        ></el-input>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchInviteDriverCodeList">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="add_isShow = !add_isShow">活动配置</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show">{{
                progress_show ? '导出中...' : '导出'
            }}</el-button>

            <!-- 导出进度条 -->
            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="司机手机号" prop="driver_phone" min-width="120"> </el-table-column>

            <el-table-column label="司机姓名" prop="driver_name" min-width="130"> </el-table-column>

            <el-table-column label="用户手机号" prop="phone" min-width="180"> </el-table-column>

            <el-table-column label="下单时间" prop="order_time"> </el-table-column>

            <el-table-column label="系统单号" prop="order_code"> </el-table-column>
            <el-table-column label="订单金额" prop="order_amount"> </el-table-column>
            <el-table-column label="奖励金额" prop="reward_amount"> </el-table-column>
        </el-table>

        <!-- 分享配置组件 -->
        <editReward :isShow="add_isShow"></editReward>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
var _this;

import editReward from './editReward.vue';

export default {
    components: {
        editReward
    },
    data() {
        return {
            search_time: [],
            progress_show: false,
            progress_data: 0,
            add_isShow: false,
            excelData: [],
            excelHead: [],

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                driver_phone: '',
                phone: '',
                order_fixed_array: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.inviteDriverCodeList();
    },

    methods: {
        toExport() {
            console.log(111);
            if(_this.tableData==null){
                this.$message.error("暂无数据，不支持导出");
                return;

            }
           

            _this.search_data.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            console.log(222);

            _this
                .$post('/Invitedrivercode/getInviteList', _this.search_data, _this.search_rules)
                .then((res) => {
                    console.log(333);
                 

                    _this.progress_show = true;

                    if (this.$route.path == '/inviteDriverCode') {
                        // 导出excel的空数组中添加数据


                        for (let i = 0; i < res.data.length; i++) {
                            
                            _this.excelData.push({
                                driver_phone: res.data[i].driver_phone,
                                driver_name: res.data[i].driver_name,
                                phone: res.data[i].phone,
                                order_time: res.data[i].order_time,
                                order_code: res.data[i].order_code,
                                order_amount: res.data[i].order_amount,
                                reward_amount: res.data[i].reward_amount
                            });
                           
                        }
                        console.log(_this.excelData, '_this.excelData');
                        console.log( res.data.driver_phone, ' res.data.driver_phone');
                        

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            console.log('if');
                           
                            _this.search_data.page = _this.search_data.page + 1;

                            _this.progress_data = Math.floor((_this.search_data.page * _this.search_data.limit / res.data.count) * 100);
                           

                            _this.getExcelData();
                        } else {
                            console.log(444);
                            console.log(_this.excelData, '_this.excelData');

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        console.log(555);
                        _this.progress_data = 0;
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');

            const tHeader = ['司机手机号', '司机姓名', '用户手机号', '时间', '系统单号', '订单金额', '奖励金额'];
            const filterVal = ['driver_phone', 'driver_name', 'phone', 'order_time', 'order_code', 'order_amount', 'reward_amount'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '扫司机工牌码拉新');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.order_fixed_array = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.order_fixed_array = '';
            }
        },

        searchInviteDriverCodeList() {
            _this.search_data.page = 1;
            _this.inviteDriverCodeList();
        },

        inviteDriverCodeList() {
            _this
                .$post('/Invitedrivercode/getInviteList', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.inviteDriverCodeList();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>